import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isBlogOpen, setIsBlogOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => {
      const next = !prev;
      if (!next) {
        setIsServicesOpen(false);
        setIsBlogOpen(false);
      }
      return next;
    });
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsServicesOpen(false);
    setIsBlogOpen(false);
  };

  return (
    <nav className="sticky top-0 z-50 bg-black/95 backdrop-blur-sm border-b border-gray-700 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex-shrink-0">
            <img
              src="/divaisetech-logo.png"
              alt="DivaiseTech"
              className="h-10 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center gap-2 text-sm relative">
            <Link
              to="/"
              className="text-white hover:text-secondary font-medium transition-colors px-3 py-2"
            >
              Home
            </Link>

            <div className="relative group">
              <button
                type="button"
                className="text-white hover:text-secondary font-medium transition-colors px-3 py-2 flex items-center gap-1"
              >
                Services <ChevronDown className="w-4 h-4" />
              </button>
              <div className="absolute left-0 top-full mt-2 w-64 bg-black border border-gray-700 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50 overflow-hidden">
                <Link
                  to="/solutions"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary border-b border-gray-700"
                >
                  All Solutions
                </Link>
                <Link
                  to="/digital-experience-platform-solutions"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary border-b border-gray-700"
                >
                  AEM Development
                </Link>
                <Link
                  to="/it-hardware-solutions"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary border-b border-gray-700"
                >
                  IT Hardware Solutions
                </Link>
                <Link
                  to="/free-aem-consultation"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary border-b border-gray-700"
                >
                  Free AEM Consultation
                </Link>
                <Link
                  to="/request-hardware-quote"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary"
                >
                  Request Hardware Quote
                </Link>
              </div>
            </div>

            <div className="relative group">
              <button
                type="button"
                className="text-white hover:text-secondary font-medium transition-colors px-3 py-2 flex items-center gap-1"
              >
                Blog <ChevronDown className="w-4 h-4" />
              </button>
              <div className="absolute left-0 top-full mt-2 w-72 bg-black border border-gray-700 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50 overflow-hidden">
                <Link
                  to="/blog/aem-6-5-vs-aem-cloud"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary border-b border-gray-700"
                >
                  AEM 6.5 vs AEM Cloud
                </Link>
                <Link
                  to="/blog/aem-dispatcher-caching-best-practices"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary border-b border-gray-700"
                >
                  AEM Dispatcher Caching
                </Link>
                <Link
                  to="/blog/how-to-plan-enterprise-hardware-procurement"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary border-b border-gray-700"
                >
                  Hardware Procurement Guide
                </Link>
                <Link
                  to="/blog/enterprise-cloud-migration-strategy"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary border-b border-gray-700"
                >
                  Cloud Migration Strategy
                </Link>
                <Link
                  to="/blog/data-center-hardware-planning-guide"
                  className="block px-4 py-3 text-white hover:bg-gray-900 hover:text-secondary"
                >
                  Data Center Planning Guide
                </Link>
              </div>
            </div>

            <Link
              to="/about"
              className="text-white hover:text-secondary font-medium transition-colors px-3 py-2"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="bg-accent text-white px-6 py-2 rounded-lg font-semibold hover:bg-accent/90 transition-all hover:shadow-lg"
            >
              Contact
            </Link>
          </div>

          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="p-2 rounded-md text-white hover:bg-gray-800"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden pb-4 space-y-2">
            <Link
              to="/"
              className="block px-3 py-2 rounded-md text-white hover:bg-gray-800 font-medium"
              onClick={closeMenu}
            >
              Home
            </Link>
            <div>
              <button
                type="button"
                onClick={() => setIsServicesOpen((prev) => !prev)}
                className="w-full flex items-center justify-between px-3 py-2 rounded-md text-white hover:bg-gray-800 font-medium"
              >
                <span>Services</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`} />
              </button>
              {isServicesOpen && (
                <div className="mt-2 ml-3 border-l border-gray-700 pl-3 space-y-1">
                  <Link
                    to="/solutions"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    All Solutions
                  </Link>
                  <Link
                    to="/digital-experience-platform-solutions"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    AEM Development
                  </Link>
                  <Link
                    to="/it-hardware-solutions"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    IT Hardware Solutions
                  </Link>
                  <Link
                    to="/free-aem-consultation"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    Free AEM Consultation
                  </Link>
                  <Link
                    to="/request-hardware-quote"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    Request Hardware Quote
                  </Link>
                </div>
              )}
            </div>
            <div>
              <button
                type="button"
                onClick={() => setIsBlogOpen((prev) => !prev)}
                className="w-full flex items-center justify-between px-3 py-2 rounded-md text-white hover:bg-gray-800 font-medium"
              >
                <span>Blog</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isBlogOpen ? 'rotate-180' : ''}`} />
              </button>
              {isBlogOpen && (
                <div className="mt-2 ml-3 border-l border-gray-700 pl-3 space-y-1">
                  <Link
                    to="/blog/aem-6-5-vs-aem-cloud"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    AEM 6.5 vs AEM Cloud
                  </Link>
                  <Link
                    to="/blog/aem-dispatcher-caching-best-practices"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    AEM Dispatcher Caching
                  </Link>
                  <Link
                    to="/blog/how-to-plan-enterprise-hardware-procurement"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    Hardware Procurement Guide
                  </Link>
                  <Link
                    to="/blog/enterprise-cloud-migration-strategy"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    Cloud Migration Strategy
                  </Link>
                  <Link
                    to="/blog/data-center-hardware-planning-guide"
                    className="block px-3 py-2 rounded-md text-white/90 hover:bg-gray-800"
                    onClick={closeMenu}
                  >
                    Data Center Planning Guide
                  </Link>
                </div>
              )}
            </div>
            <Link
              to="/about"
              className="block px-3 py-2 rounded-md text-white hover:bg-gray-800 font-medium"
              onClick={closeMenu}
            >
              About
            </Link>
            <Link
              to="/contact"
              className="block w-full bg-accent text-white px-3 py-2 rounded-lg font-semibold hover:bg-accent/90 transition-all text-center"
              onClick={closeMenu}
            >
              Contact
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
